module.exports = __webpack_public_path__ + "img/physio.654e605a.png";